"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateActiveCurrencyCode = void 0;

var _ActionTypes = _interopRequireDefault(require("pricing-pages-unified-ui/constants/ActionTypes"));

var updateActiveCurrencyCode = function updateActiveCurrencyCode(payload) {
  return {
    type: _ActionTypes.default.ACTIVE_CURRENCY_CODE_UPDATED,
    payload: payload
  };
};

exports.updateActiveCurrencyCode = updateActiveCurrencyCode;